import { useEffect, useState } from 'react';

export const useDebouncedValue = (value: string, ms: number) => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timeout = setTimeout(() => setDebounced(value), ms);

        return () => clearTimeout(timeout);
    }, [value, ms]);

    return debounced;
};
